import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import NapePiercingImage from '../../Assets/Piercing Services/nape piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function NapePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Nape Piercing UAE | 450 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Nape Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Nape Piercing 450 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={NapePiercingImage} alt="Nape Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Nape Piercing</h3>

          <p>
            Add a touch of elegance and individuality to your style with our professional nape piercing services in the UAE, available at a premium price of 450 AED. Nape piercing is a unique and stylish surface piercing placed at the back of the neck, just below the hairline, creating a subtle yet eye-catching look. This modern piercing style is perfect for individuals who want something different from traditional body piercings, offering a refined and sophisticated appearance that can be easily shown or hidden depending on your hairstyle. Whether you choose a sleek surface bar or decorative jewelry, nape piercing adds a graceful and fashionable detail to your overall look.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each nape piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Surface piercings like the nape require specialized expertise, and our experienced specialists are trained to ensure proper placement, alignment, and depth for long-lasting and aesthetically pleasing results while minimizing discomfort.
          </p>

          <p>
            Nape piercing is ideal for individuals who want a subtle yet distinctive body modification that stands out in a sophisticated way. Its placement at the back of the neck makes it a versatile option, as it can be hidden under hair for a minimal look or revealed for a bold and stylish statement. This piercing pairs beautifully with other body piercings and allows for creative jewelry choices, from simple metallic bars to decorative gemstone ends. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry design to suit your style and comfort.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic surface jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that surface piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for nape piercings due to their placement and exposure to movement and clothing. We provide detailed instructions to help you maintain proper care during the healing period, including cleaning routines, recommended products, and precautions to avoid irritation, friction, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our nape piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive excellent value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted nape piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a unique and elegant look effortlessly. Book your nape piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Nape Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NapePiercing;